export default {
  SET_MESSAGE(state, params) {
    state.message = params;
  },

  CHANGE_COUNT(state, num) {
    state.cnt += num;
  },

  SET_GRID_DATA(state, params) {
    state.gridData = params;
  },

  SET_TEMP_DATA(state, params) {
    state.tempInfo = params;
  },
  SET_AD_USER_INFO_DATA(state, params) {
    state.adUserInfoList = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/samplePage/samplePageMutation.js